<!--
 * @Description: 德育考评入口（底部）
 * @Author: 烟雨
 * @Date: 2022-04-01 10:55:08
 * @LastEditors: 烟雨
 * @LastEditTime: 2022-04-01 11:01:39
-->
<template>
  <div class="width-full" @click="handlerClick">
    <md-button class="width-full">
      {{ text }}
    </md-button>
  </div>
</template>

<script>
import { mcToast } from '@/utils/mcSdkUtils'
import { timeFormat } from '@/utils/comUtils'

export default {
  name: 'commonMoralEvaluationEntrance',
  props: {
    text: {
      type: String,
      default: '我要考评'
    }
  },

  methods: {
    handlerClick() {
      const {
        termStartDimDay,
        termEndDimDay
      } = this.$store.getters.semesterSetting
      const _date = timeFormat(new Date(), 'YYYYMMDD')
      if (_date < termStartDimDay || _date > termEndDimDay) {
        return mcToast({ msg: '当前日期不在学年学期范围内' })
      }
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped></style>
